import React, { useEffect, useState } from "react";
import {
  archiveReportService,
  getListOfUserAssessmentReports,
} from "../../services/ViewReportServices";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  convertUTCtoLocalDate,
  convertUTCtoLocalTime,
} from "../../utils/CommonUtils";
import { CircularProgress, Tooltip } from "@mui/material";
import PDFButton from "../../components/Common/pdfButton/pdfButton";
import ViewIndividualReport from "./viewIndividualReport";
import { getUserDetails, sendWebHookHandler } from "../../services/DashboardServices";
import dropdown from "../../assets/Icons/dropdown.svg";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import AcknowledgeDelete from "../../components/Common/AcknowledgeDelete/AcknowledgeDelete";
import AcknowledgeSendEmail from "../../components/Common/AcknowledgeSendEmail/AcknowledgeSendEmail";
import UnarchiveOutlinedIcon from "@mui/icons-material/UnarchiveOutlined";
import ExcelButton from "../../components/Common/ExcelButton/ExcelButton";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useOrgContext } from "../../Context/orgContext";

const ViewListUserReport = () => {
  const [pageMetaData, setPageMetaData] = useState({});
  const [page, setPage] = useState(0);
  const [listOfReports, setListofReports] = useState([]);
  const { userId } = useParams();
  const navigate = useNavigate();
  const [showListOfReports, setShowListOfReports] = useState(true);
  const location = useLocation();
  console.log("location", location);
  const queryParams = new URLSearchParams(location.search);
  const sessionId = queryParams.get("session_id");
  const [userDetails, setUserDetails] = useState({});
  const [filter, setFilter] = useState(null); //filter by status
  const [sort, setSort] = useState(null); //sort by latest first
  const [openAcknowledgeDelete, setOpenAcknowledgeDelete] = useState({
    open: false,
    sessionId: null,
  });
  const [openAcknowledgeSendEmail, setOpenAcknowledgeSendEmail] = useState({
    open: false,
    sessionId: null,
  });
  const [ tableLoading , setTableLoading ] = useState(false);
  const { orgDetails } = useOrgContext();
  const actionBtnData = orgDetails?.dashboard_config?.action_button_config;

  useEffect(() => {
    getUserDetails(userId).then((res) => {
      console.log("getUserDetails", res);
      setUserDetails(res.data);
    });
    // getListOfUserAssessmentReports(page, userId, sort, filter).then((res) => {
    //   console.log("res", res);
    //   setPageMetaData(res.data);
    //   setListofReports(res.data.user_report_details_list);
    // });
  }, []);

  useEffect(() => {
    setTableLoading(true);
    getListOfUserAssessmentReports(page, userId, sort, filter).then((res) => {
      console.log("res", res);
      setPageMetaData(res.data);
      setListofReports(res.data.user_report_details_list);
      setTableLoading(false);
    });
  }, [filter, sort]);

  useEffect(() => {
    if (sessionId) {
      setShowListOfReports(false);
    } else {
      setShowListOfReports(true);
    }
  }, [sessionId]);

  useEffect(() => {
    if (page > 0) {
      getListOfUserAssessmentReports(page, userId, sort, filter).then((res) => {
        setPageMetaData(res.data);
        setListofReports((prev) => [
          ...prev,
          ...res.data.user_report_details_list,
        ]);
      });
    }
  }, [page]);

  const refreshTable = () => {
    setTableLoading(true);
    getListOfUserAssessmentReports(page, userId, sort, filter).then((res) => {
      console.log("res", res);
      setPageMetaData(res.data);
      setListofReports(res.data.user_report_details_list);
      setTableLoading(false);
    });
  };

  const webHookHandler = async(id) => {
    setTableLoading(true);
    const data = await sendWebHookHandler(id);
    if( data ){
      refreshTable();
    }
  }

  console.log('here')
  return (
    <>
      {!showListOfReports && <ViewIndividualReport />}
      {showListOfReports && (
        <div>
          <div className="mb-11 mt-3 flex items-center justify-between">
            <div className="flex gap-2">
              <div className="text-[#101828] font-semibold text-lg">
                {userDetails && userDetails.username}’s Reports
              </div>
              <div className="bg-[#efefff] text-[#5A6AF6] font-medium text-xs px-2 rounded-2xl py-1">
                {userDetails && userDetails.total_assessments_taken} Reports
              </div>
            </div>
            <div className="flex gap-3">
              <select
                name=""
                id=""
                className="outline-none rounded appearance-none  px-3 py-2"
                style={{
                  border: "1px solid #E1E5EB",
                  backgroundImage: `url(${dropdown})`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "right 10px center",
                  backgroundSize: "20px",
                  paddingRight: "30px",
                }}
                onChange={(e) => {
                  setPage(0);
                  setFilter(e.target.value);
                }}
              >
                <option value="">All</option>
                <option value="viewed">Viewed</option>
                <option value="edited">Edited</option>
                <option value="new">New</option>
                <option value="archived">Archived</option>
                <option value="mailsent">Email Sent</option>
              </select>
              <select
                name=""
                id=""
                className="outline-none rounded appearance-none  px-3 py-2"
                style={{
                  border: "1px solid #E1E5EB",
                  backgroundImage: `url(${dropdown})`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "right 10px center",
                  backgroundSize: "20px",
                  paddingRight: "30px",
                }}
                onChange={(e) => {
                  setPage(0);
                  setSort(e.target.value);
                }}
              >
                <option value="timeDsc">Sort By: Latest First</option>
                <option value="timeAsc">Sort By: Oldest First</option>
              </select>
            </div>
          </div>
          <div className="flex items-center justify-between bg-[#415280] text-[#fff]">
            <div className="w-[80px] h-11 pl-6 py-3">Sr.no</div>
            <div className="w-[323px] pl-6 py-3">Assessment Date & Time</div>
            <div className="w-[232px] h-11 pl-6 py-3">Status</div>
            <div className="w-[290px] h-11 pl-6 py-3 text-left">
              Overall Assessment Score
            </div>
            <div className="w-[349px] h-11 pl-6 py-3 text-center">Action</div>
          </div>
          {
            tableLoading
            ? <div className="w-full flex justify-center mt-5"><CircularProgress size={40} color="info" /></div>
            : <div className="bg-[#fff]">
            {listOfReports.map((item, index) => (
              <div className="flex items-center justify-between py-3 border-b border-solid ">
                <div className="w-[80px] pl-6">{item.serial_number}</div>
                <div className="w-[323px] pl-6">
                  <div className="text-[#101828] text-sm leading-5 font-medium">
                    {convertUTCtoLocalDate(
                      item.assessment_date,
                      item.assessment_time
                    )}
                  </div>
                  <div className="text-[#475467] font-normal text-sm leading-5">
                    at &nbsp;
                    {convertUTCtoLocalTime(
                      item.assessment_date,
                      item.assessment_time
                    )}
                  </div>
                </div>
                <div className="w-[232px] pl-2">
                  {
                    orgDetails.organisation_code === "simpletx" &&
                    (item.status === "Approved" ? (
                      <div className="bg-[#E0FFD9] text-xs leading-[18px] font-medium text-[#229606] w-fit px-3 py-2 cursor-pointer text-center rounded-2xl flex items-center justify-center">
                        {item.status}
                      </div>
                    ) 
                    : (
                      <div className="text-[#175CD3] text-xs leading-[18px] font-medium bg-[#EFF8FF] w-fit px-3 py-2 cursor-pointer text-center rounded-2xl flex items-center justify-center">
                        Not Approved
                      </div>
                    ))
                  }
                  {
                    orgDetails.organisation_code !== "simpletx" &&
                    (item.status === "New" ? (
                      <div className="bg-[#E0FFD9] text-xs leading-[18px] font-medium text-[#229606] w-[60px] h-[22px] text-center rounded-2xl flex items-center justify-center">
                        {item.status}
                      </div>
                    ) : item.status === "Viewed" ? (
                      <div className="">
                        <div className="text-[#175CD3] text-xs leading-[18px] font-medium bg-[#EFF8FF] w-[60px] h-[22px] text-center rounded-2xl flex items-center justify-center">
                          {item.status}
                        </div>
                        <div className="text-[#475467] font-normal text-sm leading-5">
                          on &nbsp;
                          {convertUTCtoLocalDate(
                            item.report_last_viewed_at,
                            item.report_last_viewed_time
                          )}
                        </div>
                      </div>
                    ) : item.status === "Email sent" ? (
                      <div className="">
                        <div className="text-[#fff] text-xs leading-[18px] font-medium bg-[#415280] w-fit h-[22px] text-center rounded-2xl flex items-center justify-center px-2">
                          {item.status}
                        </div>
                        <div className="text-[#475467] font-normal text-sm leading-5">
                          on &nbsp;
                          {convertUTCtoLocalDate(item.email_sent_time_stamp, "")}
                        </div>
                      </div>
                    ) : null)
                  }
                </div>
                <div className="flex gap-1 w-[290px] pl-6 items-center">
                  <div className="text-[#3D4350] font-medium text-sm flex flex-wrap">
                    {item.interpretation}
                  </div>
                  <div
                    className="font-semibold text-xs w-7 h-7 rounded-[50%] flex items-center justify-center"
                    style={{
                      backgroundColor: item.color_code + "10",
                      color: item.color_code,
                    }}
                  >
                    {item.assessment_score}
                  </div>
                </div>
                <div className="w-[349px] pl-6 flex justify-center gap-4">
                  {item && !item.archived && actionBtnData.view_button && (
                    <Tooltip title="View">
                      <VisibilityOutlinedIcon
                        onClick={() => {
                          navigate(
                            `/user-data/${item.end_user_id}?session_id=${item.encrypted_session_id}&activeTab=reports`
                          );
                          setShowListOfReports(false);
                        }}
                        sx={{
                          width: "24px",
                          height: "24px",
                          color: "#788CFC",
                          cursor: "pointer",
                        }}
                      />
                    </Tooltip>
                  )}
                  {item && !item.archived && actionBtnData.archive_button && (
                    <Tooltip title="Archive">
                      <ArchiveOutlinedIcon
                        sx={{
                          width: "24px",
                          height: "24px",
                          color: "#788CFC",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setOpenAcknowledgeDelete({
                            open: true,
                            sessionId: item.encrypted_session_id,
                          });
                        }}
                      />
                    </Tooltip>
                  )}
                  {item && item.archived && actionBtnData.archive_button && (
                    <Tooltip title="Unarchive">
                      <UnarchiveOutlinedIcon
                        sx={{
                          width: "24px",
                          height: "24px",
                          color: "#788CFC",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          archiveReportService(
                            item.encrypted_session_id,
                            false
                          ).then((res) => {
                            setPage(0);
                            refreshTable();
                          });
                        }}
                      />
                    </Tooltip>
                  )}
                  {item && !item.archived && actionBtnData.send_email_button && (
                    <Tooltip title="Send Email">
                      <EmailOutlinedIcon
                        sx={{
                          width: "24px",
                          height: "24px",
                          color: "#788CFC",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setOpenAcknowledgeSendEmail({
                            open: true,
                            sessionId: item.encrypted_session_id,
                          });
                        }}
                      />
                    </Tooltip>
                  )}
                  {item && !item.archived && actionBtnData.download_button && <PDFButton data={item} />}
                  {item && !item.archived && actionBtnData.export_report_excel_button && <ExcelButton data={item} />}
                  {item && !item.archived && actionBtnData.push_to_webhook && (
                    <Tooltip title="Approve">
                      <CheckCircleIcon
                        sx={{
                          width: "24px",
                          height: "24px",
                          color: "#788CFC",
                          cursor: "pointer",
                        }}
                        onClick={() => webHookHandler(item.encrypted_session_id)}
                      />
                    </Tooltip>
                  )}
                </div>
              </div>
            ))}
          </div>
          }
          <div className="flex justify-center">
            {pageMetaData && !pageMetaData.last_page && (
              <div
                className="bg-[#E1E1E1] rounded-[5px] mt-[70px] w-[190px] px-8 py-3 text-[#000000] font-medium text-sm leading-5 mb-[84px] cursor-pointer"
                onClick={() => {
                  setPage((prev) => prev + 1);
                }}
              >
                {" "}
                Load More Reports
              </div>
            )}
          </div>
        </div>
      )}
      <AcknowledgeDelete
        openAcknowledgeDelete={openAcknowledgeDelete}
        closeAcknowledgeDelete={() => {
          setOpenAcknowledgeDelete({
            open: false,
            sessionId: null,
          });
        }}
        refresh={() => {
          // console.log("refresh");
          setPage(0);
          refreshTable();
        }}
      />
      <AcknowledgeSendEmail
        openAcknowledgeSendEmail={openAcknowledgeSendEmail}
        closeAcknowledgeSendEmail={() => {
          setOpenAcknowledgeSendEmail({
            open: false,
            sessionId: null,
          });
        }}
        refresh={() => {
          // console.log("refresh");
          setPage(0);
          refreshTable();
        }}
      />
    </>
  );
};

export default ViewListUserReport;
